/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentClassifierTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { DocumentScanningResult } from '../document_scanner/DocumentScannerTypes';
/**
Configuration for the document classifier.
*/
export class DocumentClassifierConfiguration {
    /** @param source {@displayType `DeepPartial<DocumentClassifierConfiguration>`} */
    constructor(source = {}) {
        /**
          If true, image will be scanned for a valid document first.
          
          Default is true
          */
        this.crop = true;
        if (source.crop !== undefined) {
            this.crop = source.crop;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            crop: this.crop,
        };
    }
}
/** @hidden */
export const DocumentClassifierStatusValues = [
    'SUCCESS',
    'FAILURE_SCANNING',
];
/** @hidden */
export const DocumentTypeValues = [
    'UNKNOWN',
    'BILL_OF_LADING',
    'PAY_SHEET',
    'SCALE_TICKET',
    'TOLL_RECEIPT',
    'WASH_RECEIPT',
];
/**
Contains the result of running the document classifier.
*/
export class DocumentClassifierResult {
    /** @param source {@displayType `DeepPartial<DocumentClassifierResult>`} */
    constructor(source = {}) {
        this._released = false;
        if (source.documentType !== undefined) {
            this.documentType = source.documentType;
        }
        else {
            throw new Error('documentType must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.status !== undefined) {
            this.status = source.status;
        }
        else {
            throw new Error('status must be present in constructor argument');
        }
        if (source.documentScanningResult !== undefined) {
            this.documentScanningResult = new DocumentScanningResult(source.documentScanningResult);
        }
        else {
            throw new Error('documentScanningResult must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            documentType: this.documentType,
            confidence: this.confidence,
            status: this.status,
            documentScanningResult: await this.documentScanningResult.serialize(config),
        };
    }
    release() {
        if (this._released) {
            return;
        }
        this.documentScanningResult.release();
        this._released = true;
    }
    async encodeImages() {
        await this.documentScanningResult.encodeImages();
    }
}
//# sourceMappingURL=DocumentClassifierTypes.js.map